module.exports = __webpack_public_path__ + "static/img/083_TO8_1731.a4a35ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/083_TO8_1731.jpg
// module id = jxNW
// module chunks = 0